import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  required,
} from 'react-admin';
import { PolygonMapInput } from './PolygonMapInput';

export const DeliveryZoneCreate = () => (
  <Create>
    <SimpleForm noValidate>
      <TextInput source="name" label="Название" validate={required()} fullWidth />
      <TextInput source="description" label="Описание" multiline rows={3} fullWidth />
      
      <PolygonMapInput
        polygonSource="polygon"
        colorSource="color"
      />
      
      <NumberInput 
        source="deliveryPrice" 
        label="Стоимость доставки (₽)" 
        validate={required()}
        min={0}
      />
      
      <NumberInput 
        source="freeDeliveryThreshold" 
        label="Сумма для бесплатной доставки (₽)" 
        helperText="При превышении этой суммы заказа - доставка бесплатная. Оставьте пустым, если не нужно."
        min={0}
      />
      
      <BooleanInput source="isActive" label="Активна" defaultValue={true} />
    </SimpleForm>
  </Create>
);
